// Libs
import React from 'react';
import 'moment/locale/en-gb';
import ReactDatePicker, { registerLocale } from 'react-datepicker';

// Localisation
import enGB from 'date-fns/locale/en-gb';

// CSS
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('en-gb', enGB);

//-------------------------------------------------------------------------------------------------------------------

class DatePicker extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.value = this.props.value;
    }

    componentDidUpdate() {
        this.value = this.props.value;
    }

    //--------------------------------------------------------------------------------------------------------------------
    //  Render
    //--------------------------------------------------------------------------------------------------------------------

    render() {
        const {
            value,
            onChange
        } = this.props;

        const props = {
            ...this.props
        };
        delete props.onChange;

        return (
            <ReactDatePicker
                selected={value || null}
                onSelect={date => {
                    this.lastValue = date;
                    this.props.onChange(date);
                }}
                onChange={date => {
                    this.lastValue = date;
                }}
                onBlur={e => {
                    this.props.onChange(this.lastValue);
                }}
                dateFormat="dd/MM/yyyy"
                locale="en-gb"
                showYearDropdown
                {...props}
            />
        );
    }
    
}

export default DatePicker;